import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {BookingsIndexComponent} from "./bookings-index/bookings-index.component";
import {BookingsDetailComponent} from "./bookings-detail/bookings-detail.component";

const routes: Routes = [
  {
    path: '',
    component: BookingsIndexComponent
  },
  {
    path: ':bookingId',
    component: BookingsDetailComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BookingsRoutingModule { }
